"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AptosNetwork = exports.UserResponseStatus = void 0;
exports.getArgs = getArgs;
const protocol_1 = require("../../../protocol");
var UserResponseStatus;
(function (UserResponseStatus) {
    UserResponseStatus["APPROVED"] = "Approved";
    UserResponseStatus["REJECTED"] = "Rejected";
})(UserResponseStatus || (exports.UserResponseStatus = UserResponseStatus = {}));
function getArgs(response) {
    if (typeof response === 'object' && response !== null && 'status' in response) {
        if (response.status === UserResponseStatus.REJECTED) {
            throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.USER_REJECTS_ERROR);
        }
        return response.args;
    }
    return response;
}
var AptosNetwork;
(function (AptosNetwork) {
    AptosNetwork["MAINNET"] = "mainnet";
    AptosNetwork["TESTNET"] = "testnet";
    AptosNetwork["DEVNET"] = "devnet";
})(AptosNetwork || (exports.AptosNetwork = AptosNetwork = {}));
